// // import React from "react";
// // import { Col, Row } from "react-bootstrap";
// // import { DiJavascript1, DiReact, DiNodejs } from "react-icons/di";
// // import { SiMaterialui, SiRedux, SiMongodb, SiHtml5 } from "react-icons/si";

// // import { FaShopify } from "react-icons/fa";
// // import { SiTypescript } from "react-icons/si";
// // import { DiJqueryLogo } from "react-icons/di";

// // const Techstack = () => {
// //   return (
// //     <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <SiHtml5 />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <DiJavascript1 />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <DiNodejs />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <DiReact />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <SiRedux />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <SiMongodb />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <DiJqueryLogo />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <SiTypescript />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <SiMaterialui />
// //       </Col>
// //       <Col xs={4} md={2} className="tech-icons">
// //         <FaShopify />
// //       </Col>
// //     </Row>
// //   );
// // };

// // export default Techstack;

// import React from "react";
// import { Col, Row } from "react-bootstrap";
// import { DiJavascript1, DiReact, DiNodejs, DiJqueryLogo } from "react-icons/di";
// import {
//   SiMaterialui,
//   SiRedux,
//   SiMongodb,
//   SiHtml5,
//   SiTypescript,
//   SiNextdotjs,
//   SiOpenai,
// } from "react-icons/si";
// import { FaShopify } from "react-icons/fa";

// const Techstack = () => {
//   return (
//     <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiHtml5 />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <DiJavascript1 />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiTypescript />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <DiNodejs />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <DiReact />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiNextdotjs />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiRedux />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiMongodb />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiMaterialui />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <DiJqueryLogo />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <FaShopify />
//       </Col>
//       <Col xs={4} md={2} className="tech-icons">
//         <SiOpenai />
//       </Col>
//     </Row>
//   );
// };

// export default Techstack;

import React from "react";
import { Row, Col } from "react-bootstrap";
import "./techstack.css";

import {
  SiHtml5,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiRedux,
  SiTailwindcss,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiPostgresql,
  SiDocker,
  SiGit,
  SiGithub,
  SiShopify,
  SiOpenai,
} from "react-icons/si";

const techStack = [
  { icon: <SiHtml5 />, name: "HTML5" },
  { icon: <SiJavascript />, name: "JavaScript" },
  { icon: <SiTypescript />, name: "TypeScript" },
  { icon: <SiReact />, name: "React.js" },
  { icon: <SiNextdotjs />, name: "Next.js" },
  { icon: <SiRedux />, name: "Redux" },
  { icon: <SiTailwindcss />, name: "Tailwind CSS" },
  { icon: <SiNodedotjs />, name: "Node.js" },
  { icon: <SiExpress />, name: "Express.js" },
  { icon: <SiMongodb />, name: "MongoDB" },
  { icon: <SiPostgresql />, name: "PostgreSQL" },
  { icon: <SiDocker />, name: "Docker" },
  { icon: <SiGit />, name: "Git" },
  { icon: <SiGithub />, name: "GitHub" },
  { icon: <SiShopify />, name: "Shopify" },
  { icon: <SiOpenai />, name: "GenAI / OpenAI" },
];

const Techstack = () => {
  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "50px",
      }}
    >
      {techStack.map((tech, index) => (
        <Col xs={4} md={2} className="tech-icons" title={tech.name} key={index}>
          <div className="tech-icon">{tech.icon}</div>
          <span className="tech-name">{tech.name}</span>
        </Col>
      ))}
    </Row>
  );
};

export default Techstack;
